import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';
import { DutyCalendar, GoogleData, toDutyCalendars } from './google-data';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GoogleCalendarService {
  constructor(private http: HttpClient) {}

  /**
   * Piquet du jour et relèves à venir, regroupés par calendrier. Les deux
   * appels partent ensemble : le backend sert les deux depuis le même cache
   * de calendriers Google, aucun n'est plus coûteux que l'autre.
   */
  getDuties(nextCount: number): Observable<DutyCalendar[]> {
    return forkJoin({
      today: this.http.get('/api/googlecalendar/today'),
      following: this.http.get('/api/googlecalendar/following'),
    }).pipe(
      map(({ today, following }) =>
        toDutyCalendars(
          new GoogleData(today),
          new GoogleData(following),
          nextCount
        )
      )
    );
  }
}
